import { dataFix } from 'global/common/dataFix';
import DropdownOptionsMenu from 'global/components/forms/elements/DropdownOptionsMenu';
import DataSidebar from 'global/components/swipers/DataSidebar';
import { appIconTypes } from 'global/enums/appIconTypes';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import ConfirmationWrapper from 'global/wrappers/ConfirmationWrapper';
import SidebarWrapper from 'global/wrappers/SidebarWrapper';
import _ from 'lodash';
import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import { dataLinkHandlers, dataLinkInitialState, dataLinkReducer } from '../../../cnr/reducers/DataLinkReducer';
import { convertHelpers } from '../../../common/convert';
import UiSaveButtons from '../../../components/buttons/UiSaveButtons';
import MenuVert from '../../../components/menus/MenuVert';
import DataLinkingMenus from '../../../viewSettings/data/DataLinkingMenus';
import Wrapper from '../../../wrappers/Wrapper';
import WrapperVertCols from '../../../wrappers/WrapperVertCols';

const _labelSize = 'tiny'

const _optionsTypes = {
  updateLinkItems: 'updateLinkItems',
  updateAppDataDocuments: 'updateAppDataDocuments',
  updateFullAppDataDocuments: 'updateFullAppDataDocuments',
}

export const DataLinkContext = createContext()

const DataLinking = (props) => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { eventInfo_state, paps_state, currentSettings_state } = states
  const { appDataDocuments, appDataLinks } = eventInfo_state ?? {}
  const { pathViews } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appDataSource } = aps_global ?? {}
  const { useAppDataLinks, appDataLinkType } = appDataSource ?? {}

  const { database_fns } = fns

  _.forEach(appDataDocuments, (dc) => {
    convertHelpers.createItemKeys(dc)
  })

  const [dataLink_state, dataLinkDispatch] = useReducer(dataLinkReducer, dataLinkInitialState({ database_fns, pathViews, appDataLinks, appDataDocuments }));
  const dataLink_handlers = dataLinkHandlers(dataLinkDispatch, dataLink_state)

  const {
    commonRelatedItems,
    currentIndex,
    allRelatedItems,
    allRelatedDocumentItems,
    selectedRelatedItems,
    selectedCommon,
    selectedLeftKey,
    selectedLeftItem,
    selectedRightKey,
    selectedRightItems,
    sortRelated,
    sortSelected,
    sortOnly,
    dataLinks,
    // updating,
    appDataDocuments_updated,
    showDataLinker,
  } = dataLink_state ?? {}

  const [showConfirmation, setShowConfirmation] = useState(false)
  const [updating, setUpdating] = useState(false)

  useEffect(() => {
    dataLink_handlers.handleInit_dataLink(appDataLinks, appDataDocuments)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeIndex = (index) => { dataLink_handlers.handle_changeIndex(index > 1 ? 1 : 0) }

  const handleFixDataIssue = (selectedLeftKey, selectedRightKey) => {

    const _appDataDocuments = _.cloneDeep(appDataDocuments)
    const _dataLinks = _.cloneDeep(dataLinks)
    const _dataLinks_left = _.cloneDeep(dataLinks[selectedLeftKey])
    const _appDataDocument_left = _.cloneDeep(appDataDocuments[selectedLeftKey])
    const _appDataDocument_right = _.cloneDeep(appDataDocuments[selectedRightKey])

    const _leftItems = {}

    _.forEach(_appDataDocument_right, (rightItem, rightItemKey) => {
      const _leftArray = rightItem[selectedLeftKey]
      if (!_.isEmpty(_leftArray)) {
        _.forEach(_leftArray, leftValue => {
          const _leftValue = _.isEmpty(leftValue) ? 0 : leftValue
          if (!_leftItems[_leftValue]) {
            _leftItems[_leftValue] = []
          }
          if (!_leftItems[_leftValue].includes(rightItemKey)) {
            _leftItems[_leftValue].push(rightItemKey)
          }
        })
      }
    })

    _.forEach(_leftItems, (leftItem, leftItemKey) => {
      if (_appDataDocument_left[leftItemKey]) {
        _appDataDocument_left[leftItemKey][selectedRightKey] = leftItem
      }
      if (!_dataLinks_left[leftItemKey]) {
        _dataLinks_left[leftItemKey] = {}
      }
      _dataLinks_left[leftItemKey][selectedRightKey] = leftItem
    })

    _dataLinks[selectedLeftKey] = _dataLinks_left
    _appDataDocuments[selectedLeftKey] = _appDataDocument_left
    dataLink_handlers.handle_ammendDataLinks(_dataLinks, _appDataDocuments)
  }

  // Get the keys of dataCollections for column 1 and 3 
  const leftMenuItems = Object.keys(appDataDocuments);
  const rightMenuItems = leftMenuItems; // Same as left menu items

  const header_selected_sub = (caption, count, oc) => <div>
    {_.startCase(caption)}
    <Label style={{ float: 'right' }} color={sortSelected ? 'green' : 'grey'} onClick={() => oc && oc()}>
      <Icon name={sortSelected ? 'check circle' : 'circle outline'} />{count}
    </Label>
  </div>

  const header_selected_related = (caption, count, oc) => <div>
    {_.startCase(caption)}
    <Label size={_labelSize} style={{ float: 'right' }} color={sortRelated ? 'black' : 'grey'} onClick={() => oc && oc()}>
      <Icon name={sortRelated ? 'check circle' : 'circle outline'} />{count}
    </Label>
  </div>

  const header_sort = (caption, oc) => <div>
    {_.startCase(caption)}{oc ? <Icon style={{ float: 'right' }} name={'sort'} color={sortOnly ? 'green' : 'grey'} onClick={() => oc()} /> : null}
  </div>

  const header_count = (caption, count) => <div>
    {_.startCase(caption)}{<Label size={_labelSize} style={{ float: 'right' }} name={'sort'}>{count}</Label>}
  </div>

  const handleUpdateLinkItems = (selectedLeftKey) => {
    dataLink_handlers.handleStartUpdate()
    dataLink_handlers.handle_updateLinks(selectedLeftKey)
  }

  const handleUpdateAppDataDocs = () => {
    normalizeDocumentReferences(appDataDocuments)
  }

  const handleUpdateFullAppDataDocs = () => {
    normalizeDocumentReferences(appDataDocuments, true)
  }

  const normalizeDocumentReferences = async (adds, updateTrueDoc) => {

    setUpdating(true)

    const result = _.cloneDeep(adds);

    Object.entries(result).forEach(([collectionKey, collectionData]) => {
      Object.values(collectionData).forEach(item => {
        Object.entries(item).forEach(([propKey, propValue]) => {
          if (Array.isArray(propValue)) {
            // If this propKey matches another document key
            if (appDataDocuments[propKey]) {
              const nameToKeyMap = Object.entries(appDataDocuments[propKey]).reduce((acc, [key, val]) => {
                acc[val.name] = key;
                return acc;
              }, {});

              // Replace names with corresponding keys
              item[propKey] = propValue.map(name => nameToKeyMap[name] || name);
            }
          }
        });
      });
    });

    await handleUpdateAllDocuments(result, updateTrueDoc)
    setUpdating(false)

    return result;
  }

  const handleUpdateAllDocuments = async (rezz, updateTrueDoc = false) => {
    const _allPromises = _.flatMap(rezz, (appDataDocument, dataKey) => {
      if (_.isEmpty(appDataDocument)) return [];

      const docsToUpdate = {};
      const individualWrites = [];

      _.forEach(appDataDocument, (itemData, itemKey) => {
        let _itemData = dataFix.removeNulls(itemData);
        _itemData = dataFix.removeUnderscoreKeys(_itemData);

        // Add to grouped doc
        docsToUpdate[itemKey] = _itemData;

        // Conditionally add individual doc writes
        if (updateTrueDoc) {
          const singleRefPath = createRefPath_event(pathViews, [dataKey, itemKey], false);
          individualWrites.push(database_fns.doc_set(singleRefPath, _itemData));
        }
      });

      // Grouped collection-level document
      const groupedRefPath = createRefPath_event(pathViews, ['_documents', dataKey], false);
      const groupedWrite = database_fns.doc_set(groupedRefPath, docsToUpdate);

      return [...individualWrites, groupedWrite];
    });

    await Promise.all(_allPromises);
  };

  const handleSelectedOnly = () => dataLink_handlers.handle_sortSelected(!sortSelected)
  const handleRelatedOnly = () => dataLink_handlers.handle_sortRelated(!sortRelated)
  const handleSortOnly = () => dataLink_handlers.handle_sortOnly(!sortOnly)

  // Handle click on column 1 (left)
  const handleLeftClick = (key) => dataLink_handlers.handle_selectedLeft(key);

  // Handle click on column 2 (left items with checkboxes)
  const handleLeftItemClick = (item) => dataLink_handlers.handle_selectedLeftItem(item);

  // Handle click on column 3 (right)
  const handleRightClick = (key) => dataLink_handlers.handle_selectedRight(key);

  const handleRightItemClick = (item) => {
    let _selectedRightItems = [...selectedRightItems];
    if (_selectedRightItems.includes(item._itemKey)) {
      _selectedRightItems = _.pull(_selectedRightItems, item._itemKey)
    } else {
      _selectedRightItems.push(item._itemKey)
    }
    dataLink_handlers.handle_selectedRightItems(_selectedRightItems, item);
  };

  const handleCommonClick = (key) => dataLink_handlers.handle_selectedCommon(key);

  const handle_showConfirmation = (opts) => {
    const { optionType } = opts ?? {}
    setShowConfirmation(optionType ? optionType : null)
  }

  const getItemCount_1 = (item) => {
    const { count: count_subs, subs } = itemCount_11(item)
    if (appDataDocuments && appDataDocuments[item]) {
      return { count: _.size(appDataDocuments[item]), subCount: count_subs, subs }
    }
    return { count: 0, subCount: count_subs }; // Default return if any check fails
  };

  const itemCount_11 = (item) => {
    const subs = []
    _.forEach(dataLinks, (dataLink, dlKey) => {
      _.forEach(dataLink, (dataLinkItem, dliKey) => {
        _.forEach(dataLinkItem, (dataLinkItemItem, dliiKey) => {
          if (item === dliiKey) {
            if (!subs.includes(dlKey)) {
              subs.push(dlKey)
            }
          }
        })
      })
    })
    return { count: subs.length, subs };
  };

  const ammendItemCounts = (items) => {
    const { _itemKey } = selectedLeftItem ?? {}
    _.forEach(items, (item) => {
      item._count = 0
      item._countSelected = 0
    })
    // list of leftItems/parentItems ie:
    const dataLink_selected = dataLinks ? dataLinks[selectedLeftKey] : {}
    _.forEach(dataLink_selected, (dlks, itemKey) => {
      _.forEach(dlks, (dlk, dlkKey) => {
        const x = _.find(items, { _itemKey: itemKey })
        if (x) {
          x._count += dlk ? _.size(dlk) : 0 // blue labels
          // if (selectedRightKey === dlkKey) {
          //   x._countSelected += dlk ? _.size(dlk) : 0 // green labels
          // } else {
          //   x._countSelected = null
          // }
        }
      })
    })
  };

  const getItemCount_related = (itemOrKey) => {
    const selectedRelated = appDataDocuments?.[selectedLeftKey]?.[selectedLeftItem?._itemKey]?.[itemOrKey]
    const relz = _.isArray(selectedRelated) ? _.size(selectedRelated) : '-'
    return { count: relz }; // Default return if any check fails
  };

  const menu_vert_parent = () => <MenuVert
    menuItems={_.sortBy(leftMenuItems)}
    activeMenuItem={selectedLeftKey}
    oc={handleLeftClick}
    occ={getItemCount_1}
    header={"Parent Item"}
    useTransition={true}
    labelColor={'black'}
  />

  const menu_vert_parent2 = (header, menuItems, selected, selectedRelated, oc, occ) => <MenuVert
    menuItems={_.sortBy(menuItems)}
    activeMenuItem={selected}
    selectedRelated={selectedRelated}
    oc={oc}
    occ={occ}
    header={header}
    useTransition={true}
  />

  const menu_vert_related = () => {
    const header = header_relatedItems("Related Items")
    const menuItems_sorted = _.sortBy(rightMenuItems, item =>
      selectedRelatedItems?.includes(item) ? 0 : 1
    );
    const _menuItems = sortRelated ? menuItems_sorted : _.sortBy(rightMenuItems)
    return <MenuVert
      menuItems={_menuItems}
      activeMenuItem={selectedRightKey}
      selectedRelated={selectedRelatedItems}
      oc={handleRightClick}
      occ={getItemCount_related}
      header={header}
      useTransition={true}
    />
  }

  const menu_vert_parentItem = () => {
    // selectedLeftKey, selectedLeftItem, handleLeftItemClick
    const header = header_count(selectedLeftKey ? _.startCase(selectedLeftKey) : 'Related Item', selectedLeftKey ? _.size(appDataDocuments[selectedLeftKey]) : 0)
    const items = selectedLeftKey ? _.map(_.orderBy(appDataDocuments[selectedLeftKey], ['lastName', 'firstName', 'name'], ['asc', 'asc', 'asc'])) : []
    ammendItemCounts(items)
    return <MenuVert
      menuKey={'ms_' + selectedLeftKey}
      menuItems={items}
      activeMenuItem={selectedLeftItem}
      oc={handleLeftItemClick}
      // occ={occ}
      header={header}
      showCount={true}
      useTransition={true}
      showKey={true}
    ></MenuVert>
  }

  const footer_fix = () => {

    const btns = []

    const handle_fix = () => {
      handleFixDataIssue(selectedLeftKey, selectedRightKey)
    }

    const handle_updateLink = () => handleUpdateLinkItems(selectedLeftKey)

    if (appDataDocuments_updated) {
      btns.push({ oc: handle_updateLink, caption: 'Update', icon: 'save', color: 'green' })
    }

    btns.push({ oc: handle_fix, caption: 'Fix Mismatch', icon: 'arrow right', })
    return <UiSaveButtons
      others={btns}
      color={'blue'}
    />
  }

  const menu_data = (data, header, activeMenuItems) => {

    let items = [];

    const _header = header_count(_.startCase(header), _.size(data))

    if (selectedRightKey) {
      let sortCriteria = ['lastName', 'firstName', 'name'];
      if (sortSelected) {
        sortCriteria = ['_isActive', 'lastName', 'firstName', 'name'];
      }
      // Perform the sorting based on the selected criteria
      items = _.map(_.orderBy(data, sortCriteria, ['asc', 'asc', 'asc', 'asc']));
    }

    return <MenuVert
      menuKey={'ms_' + selectedRightKey}
      menuItems={items}
      activeMenuItems={activeMenuItems}
      oc={handleRightItemClick}
      header={_header}
      sortSelected={sortSelected}
      useTransition={true}
      showKey={true}
    ></MenuVert>
  }

  const menu_subItems = () => {

    let _dataIssue = false

    const _appDataDocument = _.cloneDeep(appDataDocuments[selectedRightKey])
    const activeMenuItems = dataLinks?.[selectedLeftKey]?.[selectedLeftItem?._itemKey]?.[selectedRightKey];

    _.forEach(activeMenuItems, (ami) => {
      if (_appDataDocument[ami]) {
        _appDataDocument[ami]._isActive = true
      }
    })

    const _activeItems = _.filter(_appDataDocument, { _isActive: true })

    if (_.size(activeMenuItems) !== _.size(_activeItems)) {
      _dataIssue = true
    }

    const grouped = _.transform(
      _.groupBy(_.toPairs(_appDataDocument), ([key, obj]) => obj._isActive),
      (result, pairs, _isActive) => {
        const groupKey = _isActive === "true" || _isActive === true ? "selected" : "available";
        result[groupKey] = _.fromPairs(pairs);
      },
      {}
    );

    const dataLinkProps = {
      parentCollection: selectedLeftKey,
      parentCollectionKey: selectedLeftItem?._itemKey,
      linkCollection: selectedRightKey
    }

    return <Wrapper
      header={selectedRightKey ? _.startCase(selectedRightKey) : 'Related Items'}
      content={<DataLinkingMenus dlps={dataLinkProps} />}
      footer={_dataIssue && footer_fix()}
    />
  }


  const ddOptions = () => {
    const btns = []
    _.forEach(_optionsTypes, (optionType) => {
      switch (optionType) {
        default:
          btns.push({ caption: _.startCase(optionType), oc: handle_showConfirmation, icon: appIconTypes.arrowRight, fl: true, opts: { optionType: optionType } })
      }
    })
    return <DropdownOptionsMenu
      menuButtons={btns}
      caption={'Actions'}
      color={'blue'}
      icon={'content'}
      float={'left'}
    />
  }

  const footer_main = () => {
    const btns = []
    return <UiSaveButtons dropdowns={ddOptions()} others={btns} />
  }

  const header_relatedItems = (caption) => {
    return header_selected_related(caption, _.size(selectedRelatedItems), handleRelatedOnly)
  }

  const header_subItems = (caption) => {
    const activeMenuItems = dataLinks?.[selectedLeftKey]?.[selectedLeftItem?._itemKey]?.[selectedRightKey];
    return header_selected_sub(caption, activeMenuItems ? activeMenuItems.length : 0, handleSelectedOnly)
  }

  const content = () => <WrapperVertCols mvc={'data-linking'} >
    {menu_vert_parent()}
    {menu_vert_parentItem()}
    {menu_vert_related()}
    {menu_subItems()}
    {/* {menu_vert("Common Props", commonRelatedItems, selectedCommon, null, handleCommonClick)} */}
  </WrapperVertCols>

  const wrapper = () =>
    <DataLinkContext.Provider value={{ dataLink_state, dataLink_handlers }}>
      <Wrapper
        content={content()}
        footer={footer_main()}
        updating={updating}
      />
    </DataLinkContext.Provider>

  const wrapper_dl = () =>
    <DataLinkContext.Provider value={{ dataLink_state, dataLink_handlers }}>
      <Wrapper
        content={<DataLinker dataLink_state={dataLink_state} />}
        // footer={footer_main()}
        updating={updating}
      />
    </DataLinkContext.Provider>

  const wrapper_content = () => {
    return showDataLinker ?
      wrapper_dl()
      :
      wrapper()
  }

  const wrapper_confirmation = () => {
    let top = 'Are you sure you want to ' + _.startCase(showConfirmation)
    let content;
    let _handleCommit;
    switch (showConfirmation) {
      case 'updateFullAppDataDocuments':
        _handleCommit = handleUpdateFullAppDataDocs
        top += '?'
        break;
      case 'updateAppDataDocuments':
        _handleCommit = handleUpdateAppDataDocs
        top += '?'
        break;
      case 'updateLinkItems':
        _handleCommit = handleUpdateLinkItems
        top += '?'
        break;
      default:
        top += '?'
      // nothing
    }
    return <ConfirmationWrapper
      showConfirmation={showConfirmation}
      handleCommit={_handleCommit}
      handleShow={handle_showConfirmation}
      // updating={updating}
      content={content}
      top={top}
      allowCommit={true}
    />
  }

  const sidebar_right = (visible) => <DataSidebar direction={'right'} visible={visible} content={visible && wrapper_confirmation()} onHide={handle_showConfirmation} />

  const sidebar = () => <SidebarWrapper
    sidebarContent={wrapper_content()}
    sidebarRight={sidebar_right(showConfirmation)}
    sidebarOn={showConfirmation}
  />

  return sidebar()

};

export default DataLinking;

const DataLinker = ({ dataLink_state }) => {

  const { appDataDocuments, selectedLeftKey, selectedRightKey } = dataLink_state

  const _appDataDocument_left = _.cloneDeep(appDataDocuments[selectedLeftKey])
  const _appDataDocument_right = _.cloneDeep(appDataDocuments[selectedRightKey])

  const parentEntries = Object.entries(_appDataDocument_left);
  const relatedEntries = Object.entries(_appDataDocument_right);

  const toppers = () => {
    const xxx = relatedEntries.map(([rKey, rDoc]) => (
      <div className="grid-cell header-cell" key={rKey}>
        {rDoc.name}
      </div>
    ))
    return <div className='toppers'>{xxx}</div>
  }

  const rellies = (pDoc, pKey) => {
    const xxx = relatedEntries.map(([rKey]) => {
      const isRelated = pDoc.relatedDocumentKey?.includes(rKey);
      return (
        <div className={isRelated ? "grid-cell-rel" : "grid-cell"} key={`${pKey}-${rKey}`} />
      );
    })
    return <div className='rellies'>{xxx}</div>
  }

  return (
    <div className="grid-wrapper">
      <div className="header-row">
        <div className="grid-cell empty-cell"></div>
        {toppers()}
        {/* {relatedEntries.map(([rKey, rDoc]) => (
          <div className="grid-cell header-cell" key={rKey}>
            {rDoc.name}
          </div>
        ))} */}
      </div>

      {parentEntries.map(([pKey, pDoc]) => (
        <div className="content-row" key={pKey}>
          <div className="header-cell">{pDoc.name}</div>
          {rellies(pDoc, pKey)}
          {/* {relatedEntries.map(([rKey]) => {
            const isRelated = pDoc.relatedDocumentKey?.includes(rKey);
            return (
              <div className={isRelated ? "grid-cell-rel" : "grid-cell"} key={`${pKey}-${rKey}`} />
            );
          })} */}
        </div>
      ))}
    </div>
  );
};
